
export default {
  props: {
    fixture: {
      type: Object,
      default: () => ({}),
    },
    post: {
      type: Object,
      default: () => ({}),
    },
  },
  inject: [`lastUpdated`],
  data () {
    return {
      imageSize: `1536x1536`,
    };
  },
  computed: {
    image () {
      let image = null;
      if (this.post?.image) {
        image = this.post.image;
      }

      // TODO: get image from fixture in API (and set a default match image in WP)

      return {
        src: image ? image.thumbnail : this.$store.state.config.default_page_image[this.imageSize],
        srcset: image?.srcset || ``,
        alt: image?.alt || this.title,
        position: image ? this.post.acf.featured_image_position : `center center`,
      };
    },
    heroStyle () {
      return `full-width`;
    },
    isFullWidth () {
      return this.heroStyle === `full-width`;
    },
    colour () {
      return {
        '--hero-colour': this.isFullWidth
          ? `rgba(14,14,14,.7)`
          : `grey500`,
        '--hero-text-colour': this.isFullWidth
          ? `white`
          : `grey100`,
      };
    },
    isLight () {
      return this.heroStyle === `full-width`;
    },
    matchTitle () {
      if (this.fixture) {
        const homeTeam = this.getTeam(this.fixture);
        const awayTeam = this.getTeam(this.fixture, `Away`);

        return `${homeTeam.team.teamNames[0].displayName} vs ${awayTeam.team.teamNames[0].displayName}`;
      }

      return false;
    },
  },
};
